<template>
    <div>
        <div v-if="loggedOn">
            <Chat />
        </div>
    </div>
</template>

<script>
import { api } from "../config";
import { mapGetters } from "vuex";
import firebase from "firebase";
import Chat from "./Chat"
export default {
    data: () => ({
        customer: {
            name: "",
            email: "",
            contactNumber: "",
        },
        response: {},
        queryCredentials: false,
        loading: false,
        loggedOn: false,
    }),
    computed: {
        ...mapGetters({
            loggedIn: "loggedIn",
            user: "user",
            channelId: "channelId",
        }),
    },
    async mounted() {
        this.customer.name = this.$route.query.name;
        this.customer.email = this.$route.query.email;
        this.customer.contactNumber = this.$route.query.contactNumber;

        await this.login();
    },
    methods: {
        async login() {
            let self = this
            let request = await fetch(`${api}/users/customers`, {
                method: "POST",
                body: JSON.stringify(this.customer),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            self.response = await request.json();
            firebase
                .auth()
                .signInWithCustomToken(self.response.token)
                .then(async () => {
                    self.$store.dispatch("setUser", self.response.user);
                    self.$store.dispatch(
                        "setToken",
                        await firebase.auth().currentUser.getIdToken(true)
                    );

                    let request = await fetch(`${api}/channels`, {
                        method: "POST",
                        body: JSON.stringify({
                            user: self.response.user.uid,
                            website: self.$id,
                        }),
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${self.$store.getters.token}`,
                        },
                    });
                    let response = await request.json();
                    self.$store.dispatch("setChannel", response.uid);
                    self.$store.dispatch("login");
                    self.$store.dispatch("signInUser");
                    self.loggedOn = true
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
    components: {
        Chat,
    }
};
</script>